import { download } from "./../services/Download";

export default {
  install(Vue) {
    Vue.prototype.$file = { download };
  }
};
